import { render } from "./TopProfiles.vue?vue&type=template&id=7d61f83c&scoped=true"
import script from "./TopProfiles.vue?vue&type=script&lang=js"
export * from "./TopProfiles.vue?vue&type=script&lang=js"

import "./TopProfiles.vue?vue&type=style&index=0&id=7d61f83c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d61f83c"]])

export default __exports__